import useFetchOnVisible from './useFetchOnVisible'

export default useFetchOnVisible
